/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Start_ShotInputs */

const en_pc_start_shot = /** @type {(inputs: Pc_Start_ShotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the welcome screen with recommended tools`)
};

const zh_pc_start_shot = /** @type {(inputs: Pc_Start_ShotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎页与推荐工具`)
};

/**
* | output |
* | --- |
* | "the welcome screen with recommended tools" |
*
* @param {Pc_Start_ShotInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_start_shot = /** @type {((inputs?: Pc_Start_ShotInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Start_ShotInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_start_shot(inputs)
	return zh_pc_start_shot(inputs)
});
export { pc_start_shot as "pc.start.shot" }